import { Component, computed, Input, OnInit, inject } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { updateParamsObjectToPageOne } from '../../../utils/filter-utils';
import { toSignal } from '@angular/core/rxjs-interop';
import { ResponsiveService } from '../../../../_services/responsive-service/responsive.service';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';

export interface VideoTag {
  slug: string;
  name: string;
}

@Component({
  selector: 'app-tag-filter',
  imports: [NgClass, NgTemplateOutlet, NgbDropdown, NgbDropdownMenu, NgbDropdownToggle],
  templateUrl: './tag-filter.component.html',
  styleUrl: '../../../../../static/styles/components/tag-filter.component.scss',
})
export class TagFilterComponent implements OnInit {
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);
  readonly responsiveService = inject(ResponsiveService);

  @Input({ required: true }) tags: VideoTag[] = [];
  queryParams = new HttpParams();
  activeTagSlug: string | null = null;
  protected readonly isMobile = this.responsiveService.isMobile;
  private readonly currentParams = toSignal(this.route.queryParams, { initialValue: {} as Params });

  // Derive the active tag from query params
  public readonly activeTag = computed(() => {
    const params = this.currentParams();
    return (params['tags__slug'] as string) || null;
  });

  constructor() {
    this.queryParams = new HttpParams().appendAll(this.route.snapshot.queryParams);
  }

  ngOnInit(): void {
    this.activeTagSlug = this.route.snapshot.queryParams['tags__slug'] || null;
  }

  onTagClick(tagSlug: string) {
    const existingParams = this.route.snapshot.queryParams;
    this.queryParams = new HttpParams().appendAll(existingParams);

    if (this.activeTagSlug === tagSlug) {
      this.queryParams = this.queryParams.delete('tags__slug');
      this.activeTagSlug = null;
    } else {
      this.queryParams = this.queryParams.set('tags__slug', tagSlug);
      this.activeTagSlug = tagSlug;
    }

    // Page will be reset to 1 automatically by updateParamsWithFilterReset
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: updateParamsObjectToPageOne(this.queryParams),
    });
  }

  isActive(tagSlug: string): boolean {
    return this.activeTag() === tagSlug;
  }
}
